import { left, right } from 'fp-ts/lib/Either';

import { httpClientFunction } from 'domain/types';
import FeatureFlag from 'domain/entity/featureFlag';
import ReadFeatureFlagCriteria from 'use-case/featureFlags/read/readFeatureFlagCriteria';

const readFeatureFlagApiClient = (httpClient: httpClientFunction, baseUrl: string) => (criteria: ReadFeatureFlagCriteria) =>
    httpClient(`${baseUrl}/feature-flags/${encodeURIComponent(criteria.flagId)}?default=${criteria.defaultValue}`)
        .then((response) =>
            response.ok
                ? parseFeatureFlagValue(response)
                      .then((value) => right(new FeatureFlag(criteria.flagId, value)))
                      .catch(() => left({ error: new Error(), status: 500 }))
                : left({ error: new Error(), status: response.status })
        )
        .catch(() => left({ error: new Error(), status: 503 }));

const parseFeatureFlagValue = (response: Response): Promise<unknown> => {
    const contentType = response.headers.get('content-type') ?? '';

    return contentType.includes('application/json') ? response.json() : response.text();
};

export default readFeatureFlagApiClient;
